import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Award, RefreshCw } from 'lucide-react';
import { getToken } from '../../services/tokenService';

const API = process.env.REACT_APP_BACKEND_URL;
const fmt = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');
const couleur = (it) => {
  if (it.suspendue) return 'bg-red-100 text-red-800 border-red-300';
  if (it.statut_paiement === 'Acquitté') return 'bg-emerald-100 text-emerald-900 border-emerald-300';
  return 'bg-amber-100 text-amber-900 border-amber-300';
};

/** En-tête fiche membre : un badge « Adhérent COPPAM » par souscription en cours de validité. */
export function AdhesionsCoppamBadges({ membreId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!membreId) return;
    axios.get(`${API}/api/members/${encodeURIComponent(membreId)}/adhesions-coppam`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    }).then((r) => setItems(r.data?.items || [])).catch(() => setItems([]));
  }, [membreId]);

  if (!items.length) return null;
  return (
    <div className="mt-3 flex flex-col gap-1.5" data-testid="membre-adhesions-coppam">
      {items.map((it) => (
        <div key={it.id} className={`inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 rounded-lg border px-2.5 py-1 text-[11px] ${couleur(it)}`}
          data-testid={`membre-adhesion-coppam-${it.id}`}>
          <Award className="h-3.5 w-3.5" />
          <span className="font-bold">Adhérent COPPAM</span>
          <span className="font-semibold">{it.produit}</span>
          <span className="font-mono opacity-80 truncate max-w-[180px]" title={it.reference}>{it.reference}</span>
          <span>Adhésion : {fmt(it.date_adhesion)}</span>
          <span>Expiration : {fmt(it.date_expiration)}</span>
          <span className="font-bold" data-testid={`membre-adhesion-paiement-${it.id}`}>
            {it.suspendue ? 'Couverture suspendue — incident de paiement' : `Paiement : ${it.statut_paiement || '—'}`}
          </span>
          {it.renouvelable && (new Date(it.date_expiration) - Date.now()) <= 30 * 86400000 && (
            <a href={`/calculateur-batico?renouveler=${encodeURIComponent(it.id)}&membre_id=${encodeURIComponent(membreId)}`}
              className="inline-flex items-center gap-1 rounded-full bg-[#DEA900] px-2 py-0.5 text-[10px] font-bold text-white transition-opacity hover:opacity-90"
              data-testid={`membre-adhesion-renouveler-${it.id}`}>
              <RefreshCw className="h-3 w-3" /> Renouveler
            </a>
          )}
        </div>
      ))}
    </div>
  );
}
